import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <p className="mb-4" data-id="element-61">
      En "El Manual del Gym en el Living" respetamos tu privacidad y nos
      comprometemos a proteger la información personal que compartes con
      nosotros.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-62">
      1. Información que recopilamos
    </h3>
    <p className="mb-4" data-id="element-63">
      Recopilamos únicamente la información necesaria para procesar tu compra:
      nombre, correo electrónico y datos de pago. Los datos de pago son
      procesados directamente por nuestra pasarela de pago segura y nunca son
      almacenados en nuestros servidores.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-64">
      2. Uso de la información
    </h3>
    <p className="mb-4" data-id="element-65">
      Utilizamos tu correo electrónico exclusivamente para enviarte el acceso al
      PDF tras la compra y, ocasionalmente, información relevante sobre el
      producto. Nunca compartimos ni vendemos tu información a terceros.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-66">
      3. Cookies
    </h3>
    <p className="mb-4" data-id="element-67">
      Utilizamos cookies básicas para mejorar tu experiencia de navegación.
      Puedes deshabilitarlas desde la configuración de tu navegador en cualquier
      momento.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-68">
      4. Tus derechos
    </h3>
    <p className="mb-4" data-id="element-69">
      Tienes derecho a acceder, modificar o eliminar tus datos personales en
      cualquier momento. Tu información es tuya y la respetamos.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-70">
      5. Seguridad
    </h3>
    <p data-id="element-71">
      Implementamos medidas de seguridad estándar de la industria para proteger
      tu información contra accesos no autorizados, alteración o destrucción.
    </p>
  </>;
const termsContent = <>
    <p className="mb-4" data-id="element-72">
      Al adquirir "El Manual del Gym en el Living" aceptas los siguientes
      términos y condiciones. Por favor léelos atentamente antes de realizar tu
      compra.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-73">
      1. Naturaleza del producto
    </h3>
    <p className="mb-4" data-id="element-74">
      "El Manual del Gym en el Living" es un producto digital en formato PDF.
      Tras la compra recibirás acceso inmediato al contenido en tu correo
      electrónico. El producto es de descarga única y de acceso de por vida.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-75">
      2. Pago
    </h3>
    <p className="mb-4" data-id="element-76">
      El precio del producto es un pago único, sin suscripciones ni cargos
      recurrentes. Todos los precios están expresados en dólares estadounidenses
      (USD).
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-77">
      3. Política de reembolso
    </h3>
    <p className="mb-4" data-id="element-78">
      Debido a la naturaleza digital del producto y al acceso inmediato al
      contenido, todas las ventas son finales. No se ofrecen reembolsos una vez
      completada la compra y entregado el PDF.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-79">
      4. Uso del contenido
    </h3>
    <p className="mb-4" data-id="element-80">
      El contenido del manual es para uso personal exclusivo del comprador. Está
      prohibida la redistribución, reventa, copia o compartición del material
      con terceros. Todos los derechos están reservados.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-81">
      5. Aviso de salud
    </h3>
    <p className="mb-4" data-id="element-82">
      Antes de comenzar cualquier programa de ejercicios consulta con un
      profesional de la salud, especialmente si padeces alguna condición médica.
      El usuario asume toda la responsabilidad por la práctica de los ejercicios
      descritos en el manual.
    </p>

    <h3 className="text-white font-display uppercase text-lg mt-6 mb-3" data-id="element-83">
      6. Limitación de responsabilidad
    </h3>
    <p data-id="element-84">
      Los resultados pueden variar de persona a persona y dependen del
      compromiso y constancia individual. No garantizamos resultados
      específicos. No nos hacemos responsables por lesiones derivadas del uso
      incorrecto de los ejercicios.
    </p>
  </>;
export function Footer() {
  const [modal, setModal] = useState<ModalType>(null);
  const closeModal = () => setModal(null);
  return <>
      <footer className="bg-zinc-950 py-10 border-t border-zinc-900" data-id="element-85">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-87">
            <p className="text-zinc-500 text-sm text-center md:text-left" data-id="element-88">
              &copy; {new Date().getFullYear()} El Manual del Gym en el Living.
              Todos los derechos reservados.
            </p>

            <div className="flex items-center gap-6" data-id="element-89">
              <button onClick={() => setModal('privacy')} className="text-zinc-400 hover:text-brand-orange text-sm font-medium transition-colors" data-id="element-90">
                Política de Privacidad
              </button>
              <span className="text-zinc-700" data-id="element-91">|</span>
              <button onClick={() => setModal('terms')} className="text-zinc-400 hover:text-brand-orange text-sm font-medium transition-colors" data-id="element-92">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-93">
        {modal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={closeModal} className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto" data-id="element-94">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} className="bg-zinc-900 border border-zinc-800 rounded-2xl max-w-2xl w-full max-h-[85vh] flex flex-col shadow-2xl my-8" data-id="element-95">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-zinc-800 sticky top-0 bg-zinc-900 rounded-t-2xl" data-id="element-96">
                <h2 className="text-2xl md:text-3xl font-display uppercase text-white" data-id="element-97">
                  {modal === 'privacy' ? <>
                      Política de{' '}
                      <span className="text-brand-orange" data-id="element-98">Privacidad</span>
                    </> : <>
                      Términos y{' '}
                      <span className="text-brand-orange" data-id="element-99">Condiciones</span>
                    </>}
                </h2>
                <button onClick={closeModal} className="text-zinc-400 hover:text-white hover:bg-zinc-800 p-2 rounded-lg transition-colors" aria-label="Cerrar" data-id="element-100">
                  <X className="w-5 h-5" data-id="element-101" />
                </button>
              </div>

              {/* Content */}
              <div className="overflow-y-auto p-6 md:p-8 text-zinc-300 leading-relaxed" data-id="element-102">
                {modal === 'privacy' ? privacyContent : termsContent}
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-zinc-800 flex justify-end" data-id="element-103">
                <button onClick={closeModal} className="bg-brand-orange hover:bg-orange-600 text-white font-display uppercase tracking-wider py-3 px-6 rounded-lg transition-colors" data-id="element-104">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}